import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const gettotalusersbyusertypeThunk = createAsyncThunk("users/gettotalusersbyusertype", async (usertype) => {
  let response = await api.get("gettotalusersbyusertype/" + usertype);
  return response.data;
});

export const getdistrictsofstateThunk = createAsyncThunk("users/getdistrictsofstate", async (stateid) => {
  let response = await api.get("getdistrictsofstate/" + stateid);
  return response.data;
});

export const getblocksofdistrictsThunk = createAsyncThunk("users/getblocksofdistricts", async ({stateid, districtid}) => {
  let response = await api.get("getblocksofdistricts/" + stateid+"/"+districtid);
  return response.data;
});